import { Base64 } from "js-base64"

export default {
    data() {
        return {
            userTableHeader: [
                { prop: 'index', label: this.$t('teamDetail.XH'), width: '160' },
                { prop: 'playerName', label: this.$t('teamDetail.XM'),width: '160' },
                { prop: 'playerNo', label: this.$t('teamDetail.ID'), width: '160' },
                { prop: 'stationName', label: this.$t('teamDetail.GW'), width: '160' },
                { prop: 'leaderFlagName', label: this.$t('teamDetail.SF'),  }
            ],
            lxTableHeader: [
                { prop: 'sortNo', label: this.$t('teamDetail.LXCS'), width: '150px' },
                { prop: 'startTimeSubmitTime', label: this.$t('teamDetail.LXSJ') },
                { prop: 'totalScore', label: this.$t('teamDetail.TDCJ'), auth: [['teranch', 'student'], 'pro'], width: "100px" },
                {
                    prop: 'operation', label: this.$t('teamDetail.operation'), auth: [['teranch', 'student'], 'pro'], SlotType: {
                        buttons: [
                            {
                                name: this.$t('teamDetail.CK'),
                                emitName: 'show' // 事件Type 必传
                            }
                        ]
                    }, width: '70px'
                }
            ],
            planId: '',
            teamId: '',
            userTableData: [

            ],
            teamData: {},
            edit: false,
            dialogData: {
                titleText: this.$t('teamDetail.TJCY'),
                addLxDialog: false,
                dialogWidth: '600px'
            },
            studentTableData: [],
            studentTableDataAll: [],
            studentListTableHeader: [
                { prop: 'index', label: this.$t('teamDetail.XH'), width: '160' },
                { prop: 'playerName', label: this.$t('teamDetail.XM') },
                { prop: 'playerNo', label: this.$t('teamDetail.ID') },
            ],
            inputVal: '',
            activeTableData: {},
            tableActiveIndex: '',
            planData: {}
        }
    },
    created() {
        let planData = JSON.parse(Base64.decode(this.$route.query.q))
        this.planId = planData.id || planData.planId
        this.teamId = planData.teamId
        this.planData = planData
    },
    computed: {
        lxTableHeaderFilter() {
            // && (answerFlag > 0)
            let { scoreFlag } = this.planData
            return this.lxTableHeader.map(item => {
                if (item.prop === 'totalScore' || item.prop === 'operation') {
                    if (scoreFlag == 1) {
                        return item
                    } else {
                        return false
                    }
                }
                return item
            }).filter(item => item)
        }
    }
}